<template>
  <transition name="cookie-fade">
    <aside v-if="isVisible" class="cookie-info">
      <p class="cookie-info__text">{{ $t("cookiesInfo") }}</p>

      <div class="cookie-info__actions">
        <button class="cookie-info__button" @click="reject">{{ $t("cookiesReject") }}</button>
        <button class="cookie-info__button" @click="accept">{{ $t("cookiesAccept") }}</button>
      </div>
    </aside>
  </transition>
</template>

<script>
import { isDecided, setStatus, GRANTED, DENIED } from "@/cookieConsent"
import { enableAnalytics, disableAnalytics } from "@/analytics"

export default {
  name: "CookieInfo",

  computed: {
    isVisible: function () {
      // Na ekranach display belki nie pokazujemy — to wewnętrzny sprzęt, tam śledzenie leci
      // zawsze (patrz main.js). W widoku live (embed) nie ma komu wyrazić zgody,
      // więc analityka po prostu się nie włącza.
      if (this.$route.meta.display || this.$route.meta.hideFooter) return false
      return !isDecided()
    },
  },

  methods: {
    accept() {
      setStatus(GRANTED)
      enableAnalytics()
    },

    reject() {
      setStatus(DENIED)
      disableAnalytics()
    },
  },
}
</script>

<style scoped lang="scss">
.cookie-info {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  color: #fff;
  background: $secondary;
  font-size: 0.75rem;
  padding: 1rem 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  box-shadow: 0 -2px 10px rgba(#000, 0.2);

  @media (min-width: 900px) {
    flex-direction: row;
    justify-content: center;
    gap: 1.5rem;
  }
}

.cookie-info__text {
  margin: 0;
  text-align: center;
  max-width: 800px;
}

.cookie-info__actions {
  display: flex;
  gap: 0.75rem;
  flex-shrink: 0;
}

// Oba przyciski wyglądają identycznie — odrzucenie musi być tak samo łatwe jak zgoda.
.cookie-info__button {
  color: #fff;
  font-size: 0.7rem;
  font-weight: bold;
  text-transform: uppercase;
  background: $primary;
  padding: 0.6rem 1.5rem;
  white-space: nowrap;
  transition: background $transition;

  &:hover {
    background: lighten($primary, 7%);
  }
}

.cookie-fade-enter-active,
.cookie-fade-leave-active {
  transition: opacity 250ms, transform 250ms;
}

.cookie-fade-enter,
.cookie-fade-leave-to {
  opacity: 0;
  transform: translateY(100%);
}
</style>
